var _templateObject;

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import { bool, string } from 'prop-types';
import styled from 'styled-components';
import { hexToRgb } from '@gympass/yoga-common';
import Button from './Button';
var Link = styled(Button)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref) {
  var full = _ref.full,
      secondary = _ref.secondary,
      button = _ref.theme.yoga.components.button;
  var state = secondary ? 'secondary' : 'primary';
  return "\n      height: unset;\n      padding: 0;\n      background-color: unset;\n      border: none;\n      border-radius: 0;\n      color: " + button.types.link.font[state].color + ";\n\n      &:disabled,\n      &:not([disabled]):hover,\n      &:not([disabled]):focus,\n      &:not([disabled]):active {\n        box-shadow: unset;\n        background-color: unset;\n      }\n\n      &:not([disabled]):hover  {\n        color: " + hexToRgb(button.types.link.font[state].color, 0.5) + ";\n      }\n\n      &:not([disabled]):focus, &:not([disabled]):active {\n        color: " + hexToRgb(button.types.link.font[state].color, 0.75) + ";\n      }\n\n      &:disabled {\n        color: " + button.types.link.font.disabled.color + ";\n      }\n\n      " + (full ? 'width: 100%' : '') + "\n    ";
});

var ButtonLink = function ButtonLink(props) {
  return /*#__PURE__*/React.createElement(Link, props);
};

ButtonLink.propTypes = {
  disabled: bool,
  secondary: bool,
  href: string
};
ButtonLink.defaultProps = {
  disabled: false,
  secondary: false,
  href: undefined
};
ButtonLink.displayName = 'Button.Link';
export default ButtonLink;